import ReactPaginate from "react-paginate";
import SearchableSelect from "../../components/searchableSelect";
import { useState } from "react";
import DonutChart from "../../staticComps/donutchart";
import CombinedChart from "../../staticComps/stackedBarWithLineChart";
import '../../assets/stylesheet/multiSelectInputType.css';


const SummaryTab = ({ dcData, bData, infoData, tableData }) => {
  const requestResponseSummaryData = {
    labels: ["Responded", "Not Responded"],
    datasets: [
      {
        data: [dcData.Responded, dcData.NotResponded],
        backgroundColor: ["#04559f", "#90a9c0"],

        borderWidth: 0,
      },
    ],
  };

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handlePageSizeChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const sortedData = [...tableData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  const filteredData = sortedData.filter(item => {
    const searchLower = searchTerm.toLowerCase();
    return Object.values(item).some(value =>
      String(value).toLowerCase().includes(searchLower)
    );
  });
  const paginatedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <>
      <div className="row g-2 mb-2">
        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <div className="card">
            <div className="card-body">
              <div className="card-content">
                <div style={{ height: "250px", width: "100%" }}>
                  <DonutChart data={requestResponseSummaryData} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
          <div className="card">
            <div className="card-body">
              <div className="card-content">
                <div style={{ height: "250px", width: "100%" }}>
                  <CombinedChart chartData={bData} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Data Status */}
      <div className="row g-2 mb-2">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h4 className="page-sub-title">Data Status</h4>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center">
                  <div
                    className="eng-summary eng-summary-1"
                    style={{ minHeight: "100px" }}
                  >
                    <div>
                      <div
                        className="service-name"
                        style={{
                          fontSize: "16px",
                          marginBottom: "10px",
                          paddingTop: "20px",
                        }}
                      >
                        Requests Sent
                      </div>
                      <div
                        className="service-count"
                        style={{ paddingBottom: "20px" }}
                      >
                        {infoData.RequestsDelivered}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center">
                  <div
                    className="eng-summary eng-summary-2"
                    style={{ minHeight: "100px" }}
                  >
                    <div>
                      <div
                        className="service-name"
                        style={{
                          fontSize: "16px",
                          marginBottom: "10px",
                          paddingTop: "20px",
                        }}
                      >
                        Duplicates
                      </div>
                      <div
                        className="service-count"
                        style={{ paddingBottom: "20px" }}
                      >
                        NA
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center">
                  <div
                    className="eng-summary eng-summary-1"
                    style={{ minHeight: "100px" }}
                  >
                    <div>
                      <div
                        className="service-name"
                        style={{
                          fontSize: "16px",
                          marginBottom: "10px",
                          paddingTop: "20px",
                        }}
                      >
                        Incorrect
                      </div>
                      <div
                        className="service-count"
                        style={{ paddingBottom: "20px" }}
                      >
                        NA
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center">
                  <div
                    className="eng-summary eng-summary-2"
                    style={{ minHeight: "100px" }}
                  >
                    <div>
                      <div
                        className="service-name"
                        style={{
                          fontSize: "16px",
                          marginBottom: "10px",
                          paddingTop: "20px",
                        }}
                      >
                        People Contacted
                      </div>
                      <div
                        className="service-count"
                        style={{ paddingBottom: "20px" }}
                      >
                        {infoData.PeopleContacted}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center">
                  <div
                    className="eng-summary eng-summary-1"
                    style={{ minHeight: "100px" }}
                  >
                    <div>
                      <div
                        className="service-name"
                        style={{
                          fontSize: "16px",
                          marginBottom: "10px",
                          paddingTop: "20px",
                        }}
                      >
                        Responses
                      </div>
                      <div
                        className="service-count"
                        style={{ paddingBottom: "20px" }}
                      >
                        {infoData.Responses}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center">
                  <div
                    className="eng-summary eng-summary-2"
                    style={{ minHeight: "100px" }}
                  >
                    <div>
                      <div
                        className="service-name"
                        style={{
                          fontSize: "16px",
                          marginBottom: "10px",
                          paddingTop: "20px",
                        }}
                      >
                        Response Rate
                      </div>
                      <div
                        className="service-count"
                        style={{ paddingBottom: "20px" }}
                      >
                        {infoData.ResponseRate}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* request response and response rate table */}
      <div className="row g-2 mb-2">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h4 className="page-sub-title">
            Request, Response and Response Rate Table
          </h4>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-12 col-sm-6 col-md-6">
                <p className='mb-1 me-1 paginationTotalCount'>Total items: {filteredData.length}</p>
                  <div className="d-flex align-items-center">
                    <label htmlFor="page-size" className="item-per-page">
                      Items per page:
                    </label>
                    <select
                      className="form-control-sm did-floating-select h-30 w-50px px-2 ms-1 me-3 mb-1"
                      id="page-size"
                      value={itemsPerPage}
                      onChange={handlePageSizeChange}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-6">
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="table-responsive custom-table custom-table-vertical-center">
                    <table className="table table-sm table-bordered mb-2">
                      <thead>
                        <tr>
                          <th onClick={() => handleSort("RespondedOn")}>
                            Date{" "}
                            {sortConfig.key === "RespondedOn"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th onClick={() => handleSort("RequestsDelivered")}>
                            Requests Sent{" "}
                            {sortConfig.key === "RequestsDelivered"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("PeopleContacted")}
                          >
                            People Contacted{" "}
                            {sortConfig.key === "PeopleContacted"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("Responses")}
                          >
                            Responses{" "}
                            {sortConfig.key === "Responses"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("ResponseRate")}
                          >
                            Response Rate{" "}
                            {sortConfig.key === "ResponseRate"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          {/* <th
                            className="text-center"
                            onClick={() => handleSort("InvitationSms")}
                          >
                            Invitation SMS{" "}
                            {sortConfig.key === "InvitationSms"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-center"
                            onClick={() => handleSort("ReminderSms")}
                          >
                            Reminder SMS{" "}
                            {sortConfig.key === "ReminderSms"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((item) => (
                          <tr key={item.Id}>
                            <td className="text-center">
                              {" "}
                              {new Date(item.RespondedOn).toLocaleDateString(
                                "en-GB",
                                {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                }
                              )}{" "}
                            </td>
                            <td className="text-center">
                              {item.RequestsDelivered}
                            </td>
                            <td className="text-center">
                              {item.PeopleContacted}
                            </td>
                            <td className="text-center">{item.Responses}</td>
                            <td className="text-center">{item.ResponseRate}%</td>
                            {/* <td className="text-center">
                              {item.InvitationSms}
                            </td>
                            <td className="text-center">{item.ReminderSms}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SummaryTab;
